import dynamic from 'next/dynamic';
import React, { createContext, useContext, useState, ReactNode } from 'react';

import { ViewerContext } from '@vimeo/viewer';

import { UpsellModalProps } from '../../components/UpsellModal';

const UpsellModal = dynamic(() => import('@vimeo/upsell-modal'));

type ModalContextState =
  | { isActive: true; state: UpsellModalProps }
  | { isActive: false; state: null };

type ModalContextDispatch = {
  setModalContextState: (state: ModalContextState) => void;
};

export const ModalContextDispatch = createContext<ModalContextDispatch>({
  setModalContextState: () => console.log('noop'),
});

export const UpsellModalProvider = ({ children }: { children: ReactNode }) => {
  const viewer = useContext(ViewerContext);

  const [modalContextState, setModalContextState] = useState<ModalContextState>({
    isActive: false,
    state: null,
  });

  const { isActive, state } = modalContextState;

  return (
    <ModalContextDispatch.Provider value={{ setModalContextState }}>
      {children}
      {isActive && (
        <UpsellModal
          apiUrl={viewer?.apiUrl}
          userConfig={{ jwt: viewer?.jwt, userId: viewer?.user?.id }}
          templateType="default"
          {...state}
        />
      )}
    </ModalContextDispatch.Provider>
  );
};
